// Local translations
export const T = {
  en_GB: {
    pdfDocuments: "PDF Documents",
    pdfDescription: "Generate and download PDF documents from this flow",
    failedToLoadTemplates: "Failed to load PDF templates",
    deletePdf: "Delete PDF",
    deleteConfirmation: (name: string) => `Are you sure you want to delete the PDF for "${name}"?`,
    delete: "Delete",
    cancel: "Cancel",
    failedToGeneratePdf: "Failed to generate PDF",
    failedToDeletePdf: "Failed to delete PDF",
    completed: "Completed",
    pending: "Pending",
    generating: "Generating...",
    failed: "Failed",
    noTemplatesConfigured: "No PDF template configured for this flow.",
    goToSettings: "Go to Settings -> PDF Templates to create one.",
    lockedWarning:
      "PDF generation and deletion are disabled because documents are currently in the signing process or have been signed. Cancel the signature request or delete the signed documents from the Signatures tab to make changes.",
    generateNewPdf: "Generate New PDF",
    generatePdfButton: "Generate PDF",
    generatedPdfs: "Generated PDFs",
    template: "Template",
    status: "Status",
    generated: "Generated",
    actions: "Actions",
    unknownTemplate: "Unknown Template",
    download: "Download",
    cannotDeleteLocked:
      "Cannot delete PDFs while signing process is active or documents are signed",
    generationFailed: "Generation failed",
    processing: "Processing...",
    noPdfsGenerated: 'No PDFs generated yet. Click "Generate PDF" to create one.',
    missingDocumentsWarning: "The following product documents could not be included in the PDF:",
  },
  nb_NO: {
    pdfDocuments: "PDF-dokumenter",
    pdfDescription: "Generer og last ned PDF-dokumenter fra denne flyten",
    failedToLoadTemplates: "Kunne ikke laste PDF-maler",
    deletePdf: "Slett PDF",
    deleteConfirmation: (name: string) => `Er du sikker på at du vil slette PDF-en for "${name}"?`,
    delete: "Slett",
    cancel: "Avbryt",
    failedToGeneratePdf: "Kunne ikke generere PDF",
    failedToDeletePdf: "Kunne ikke slette PDF",
    completed: "Fullført",
    pending: "Venter",
    generating: "Genererer...",
    failed: "Feilet",
    noTemplatesConfigured: "Ingen PDF-mal er konfigurert for denne flyten.",
    goToSettings: "Gå til Innstillinger -> PDF-maler for å opprette en.",
    lockedWarning:
      "PDF-generering og sletting er deaktivert fordi dokumenter er i signeringsprosessen eller er signert. Avbryt signeringsforespørselen eller slett de signerte dokumentene fra Signaturer-fanen for å gjøre endringer.",
    generateNewPdf: "Generer ny PDF",
    generatePdfButton: "Generer PDF",
    generatedPdfs: "Genererte PDF-er",
    template: "Mal",
    status: "Status",
    generated: "Generert",
    actions: "Handlinger",
    unknownTemplate: "Ukjent mal",
    download: "Last ned",
    cannotDeleteLocked:
      "Kan ikke slette PDF-er mens signeringsprosessen er aktiv eller dokumenter er signert",
    generationFailed: "Generering feilet",
    processing: "Behandler...",
    noPdfsGenerated: 'Ingen PDF-er generert ennå. Klikk "Generer PDF" for å opprette en.',
    missingDocumentsWarning: "Følgende produktdokumenter kunne ikke inkluderes i PDF-en:",
  },
} as const;
